import { Button } from "@/components/ui/button";
import { Map } from "lucide-react";
import { Dispatch, FC, SetStateAction } from "react";

interface Props {
    showLegend: boolean;
    setShowLegend: Dispatch<SetStateAction<boolean>>;
}

const ShowLegend: FC<Props> = ({showLegend, setShowLegend}) => (
  <div className="relative">
    <Button
      variant={showLegend ? "default" : "outline"}
      className={`py-1 cursor-pointer ${!showLegend && "opacity-50"}`}
      onClick={() => setShowLegend((prev) => !prev)}
      title="Show orders"
    >
      <Map className="w-4 h-4" />
    </Button>
  </div>
);

export default ShowLegend